import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'
import { mapActions, mapGetters, mapMutations } from 'vuex';
import * as accountTypes from '@account/store/types';
import * as types from '@reserve/store/types'
import { EnumCalendarViewType } from '../types';
import { IEDate, uGetDateFormat } from '@/modules/@appbase/util';
import { getWeekNumber, getWeekNumberDate } from '@reserve/disp-helper';

import DatePicker from '@appbase/components/DatePicker/DatePicker.vue';

@Component({
    components: {
        DatePicker
    },

    computed: mapGetters({
        current: accountTypes.CURRENT,
        isLoading: types.CALENDAR_LOADING,
        viewMode: types.CALENDAR_VIEWMODE,
        currentDate: types.CALENDAR_DATE_CURRENT,
        rightPaneOpen: types.CALENDAR_RIGHTPANE_OPEN,
        leftPaneOpen: types.CALENDAR_LEFTPANE_OPEN,
        searchSet: types.CALENDAR_SEARCHSET,
        listViewOpen: types.MAIN_LISTVIEW_OPEN,
        lastRefresh: types.CALENDAR_LAST_REFRESH
    }),

    methods: {
        ...mapActions({
            selectDate: types.CALENDAR_DATE_SELECTRELOAD,
            toggleRightPane: types.CALENDAR_TOGGLE_RIGHTPANE,
            toggleLeftPane: types.CALENDAR_TOGGLE_LEFTPANE,
            searchEvents: types.CALENDAR_SEARCH_EVENTS_LOAD,
            searchSetUpdate: types.CALENDAR_SEARCHSET_UPDATE,
            toggleListView: types.TOGGLE_MAIN_LISTVIEW,
            loadEvents: types.CALENDAR_DATE_SELECTRELOAD        
        }),

        ...mapMutations({
            setLastRefresh: types.CALENDAR_LAST_REFRESH
        })
    }
    
    
    
})
export default class ViewHeader  extends Vue {     
    selectDate!: (dateItem: reserve.DateItem) => Promise<any>;
    toggleRightPane!: (payload: boolean) => void;
    toggleLeftPane!: (payload: boolean) => void;
    searchEvents!: (payload?: reserve.ReserveSearchSet) => Promise<any>;
    searchSetUpdate!: (payload: reserve.ReserveSearchSet) => void;
    toggleListView!: (payload: boolean) => void;
    loadEvents!: (refreshDate: reserve.DateItem) => Promise<any[]>;
    setLastRefresh!: (timeInMills: number) => void;

    current!: account.TCurrent;
    isLoading!: boolean;
    currentDate!: reserve.DateItem;
    viewMode!: EnumCalendarViewType;
    rightPaneOpen!: boolean;
    leftPaneOpen!: boolean;
    searchSet!: reserve.ReserveSearchSet;
    listViewOpen!: boolean;
    lastRefresh!: number | null;

    dispHeaderText: string = "";
    showSearchModal: boolean = false;
    modalSearchSet: reserve.ReserveSearchSet = {
        reserveContent: "",
        reserveTitle: "",
        reserverName: "",
        searchStart: uGetDateFormat('yyyy-MM-dd', IEDate(new Date())),
        searchEnd: uGetDateFormat('yyyy-MM-dd', IEDate(new Date())),
    }
    
    get routeName() {
        return this.$route.name;
    }

    @Watch('currentDate')
    @Watch('viewMode')
    onCurrentDateChanged() {       
        this.setHeaderText(this.currentDate.date);
    }
    
    created() {                
        this.onCurrentDateChanged();

        var today = new Date();    
        this.modalSearchSet.searchStart = uGetDateFormat('yyyy-MM-dd', IEDate(today));
    
        var endDate = new Date();
        endDate.setMonth(endDate.getMonth() + 1);
        endDate.setDate(endDate.getDate() - 1);
        this.modalSearchSet.searchEnd = uGetDateFormat('yyyy-MM-dd', IEDate(endDate));
    }

    mounted() {    
        this.$nextTick(() => {
            this.syncLeftSideBar();
        })                               
    }

    setHeaderText(currentDate: Date) {        
        switch(this.viewMode) {
            case EnumCalendarViewType.Daily:
            case EnumCalendarViewType.Merge:
                {
                    this.dispHeaderText = this.current.userConfig.language === 'ko-KR' ?
                        uGetDateFormat('yyyy년 MM월 dd일', IEDate(currentDate)) :
                        uGetDateFormat('dd/MM/yyyy', IEDate(currentDate));
                }
                break;
            case EnumCalendarViewType.Week: 
                {
                    if(this.current.userConfig.language === 'ko-KR') {
                        this.dispHeaderText = `${uGetDateFormat('yyyy년', IEDate(currentDate))} ${getWeekNumberDate(currentDate)}`
                    } else {
                        this.dispHeaderText = `${getWeekNumber(currentDate)}th Week ${uGetDateFormat('MM/yyyy', IEDate(currentDate))}`
                    }
                }    
                break;
            default:
                {
                    this.dispHeaderText = this.current.userConfig.language === 'ko-KR' ?
                        uGetDateFormat('yyyy년 MM월', IEDate(currentDate)) :
                        uGetDateFormat('MM/yyyy', IEDate(currentDate));
                }
                break;                       
        }
    }

    syncLeftSideBar() {        
        var navElem = document.getElementById('snb') as HTMLDivElement;

        if(this.leftPaneOpen) {
            navElem.classList.add('sidenav-on');
            navElem.classList.remove('sidenav-off');
        } else {
            navElem.classList.add('sidenav-off');
            navElem.classList.remove('sidenav-on');
        }   
    }

    changeView(type: string) {
        if(this.isLoading)
            return;
            
        // MENUID 파라메터가 있으면 전달한다.
        const { MENUID } = this.$route.query;
        if (MENUID){
            this.$router.push({ name: type, query: { MENUID: MENUID } });
        }
        else {
            this.$router.push({ name: type });
        }
    }

    onToggleLeftPane(toggle: boolean) {  
        this.toggleLeftPane(toggle);   
        this.syncLeftSideBar();
    }

    goToday() {
        if(this.isLoading)
            return;

        var todayItem: reserve.DateItem = {
            ...this.currentDate,
            date: new Date()
        }

        this.selectDate(todayItem);
    }

    goNext() {
        if(this.isLoading)
            return;

        var nextItem: reserve.DateItem = {
            ...this.currentDate
        }

        switch(this.viewMode) {
            case EnumCalendarViewType.Month:
                nextItem.date.setMonth(nextItem.date.getMonth() + 1);
                break;
            case EnumCalendarViewType.Week:
                nextItem.date.setDate(nextItem.date.getDate() + 7);
                break;
            case EnumCalendarViewType.Daily:
            case EnumCalendarViewType.Merge:
                nextItem.date.setDate(nextItem.date.getDate() + 1);
                break;    
        }

        this.selectDate(nextItem);
    }

    goPrev() {
        if(this.isLoading)
            return;

        var prevItem: reserve.DateItem = {
            ...this.currentDate
        }

        switch(this.viewMode) {
            case EnumCalendarViewType.Month:
                prevItem.date.setMonth(prevItem.date.getMonth() - 1);
                break;
            case EnumCalendarViewType.Week:
                prevItem.date.setDate(prevItem.date.getDate() - 7);
                break;
            case EnumCalendarViewType.Daily:
            case EnumCalendarViewType.Merge:
                prevItem.date.setDate(prevItem.date.getDate() - 1);
                break;    
        }

        this.selectDate(prevItem);
    }

    onToggleRighePane(toggle: boolean) {
        this.toggleRightPane(toggle);
    }

    onSearchClick() {
        this.searchSetUpdate(this.modalSearchSet);
        this.searchEvents()
            .then(res => this.$router.push({ name: 'reserve-search' }))
            .finally(() => this.showSearchModal = false);
    }

    toggleSearchModal() {
        this.showSearchModal = !this.showSearchModal;
    }

    onListViewClick() {
        this.toggleListView(!this.listViewOpen);
    }

    onRefreshClick() {
        let currentTick: number = (new Date()).getTime();
        if(this.lastRefresh != null) {
            let refreshTerm = currentTick - this.lastRefresh;
            
            if(refreshTerm <= (5 * 1000)) {
                (window as any).alertAsync(this.$t('새로고침_경고').toString());
                return;
            }
        }

        this.setLastRefresh(currentTick);
        this.loadEvents(this.currentDate);        
    }
}